import Navbar from "./components/Navbar";
// import HeroSection from "./components/HeroSection";
// import TrustStrip from "./components/TrustStrip";
// import ServicesSection from "./components/ServicesSection";
// import UnibuilderSpotlight from "./components/UnibuilderSpotlight";
// import IndustriesGrid from "./components/IndustriesGrid";
// import WhyChooseUs from "./components/WhyChooseUs";
// import TalkToSupport from "./components/TalkToSupport";
// import GrowingBusiness from "./components/GrowingBusiness";
// import ReadyToBuild from "./components/ReadyToBuild";
import Footer from "./components/Footer";
import MainRouter from "./MainRouter";

function App() {
  return (
    <div className="App">
      <Navbar />
      {/* <HeroSection />
      <TrustStrip />
      <ServicesSection />
      <UnibuilderSpotlight />
      <IndustriesGrid />
      <WhyChooseUs />
      <TalkToSupport />
      <GrowingBusiness />
      <ReadyToBuild /> */}
      <MainRouter />
      <Footer />
    </div>
  );
}

export default App;
